module.exports = __webpack_public_path__ + "img/back-arrow.d3459e95.svg";